// frontend/src/api/axios.ts
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.solquest.fun/api',
  withCredentials: true,    // ← send cookies
  headers: {
    'Content-Type': 'application/json',
  }
});

// before each request, grab the latest token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
